import React, { useState } from "react";
import { Plus, Trash2 } from "lucide-react";

export default function PollComposer({ onSubmit, onClose }) {
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(["", ""]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const setOption = (i, value) => setOptions(prev => prev.map((o, idx) => idx === i ? value : o));
  const addOption = () => { if (options.length < 8) setOptions(prev => [...prev, ""]); };
  const removeOption = i => setOptions(prev => prev.filter((_, idx) => idx !== i));

  const submit = async e => {
    e.preventDefault();
    const cleanOptions = options.map(o => o.trim()).filter(Boolean);
    if (!question.trim() || cleanOptions.length < 2) {
      setError("Нужен вопрос и минимум 2 варианта ответа");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await onSubmit({ question: question.trim(), options: cleanOptions });
      onClose();
    } catch (err) {
      setError(err.message || "Не удалось создать опрос");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: 380 }}>
        <div className="modal-header">
          <h2 className="modal-title">Опрос</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {error && <div className="auth-error">{error}</div>}
          <input
            className="auth-input" value={question} onChange={e => setQuestion(e.target.value)}
            placeholder="Например: как бы вы вели пациента?" maxLength={500} required autoFocus
          />
          {options.map((o, i) => (
            <div key={i} style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <input
                className="auth-input" value={o} onChange={e => setOption(i, e.target.value)}
                placeholder={`Вариант ${i + 1}`} maxLength={200}
              />
              {options.length > 2 && (
                <button type="button" onClick={() => removeOption(i)}
                  style={{ background: "none", border: "none", color: "#c0392b", cursor: "pointer", display: "flex", padding: 4 }}>
                  <Trash2 size={16} strokeWidth={2} />
                </button>
              )}
            </div>
          ))}
          {options.length < 8 && (
            <button type="button" onClick={addOption}
              style={{ background: "none", color: "#007c84", border: "1.5px dashed #c4ceda", borderRadius: 8,
                padding: "6px 10px", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6,
                fontSize: "0.88rem", justifyContent: "center" }}>
              <Plus size={14} strokeWidth={2.4} /> Добавить вариант
            </button>
          )}
          <button type="submit" disabled={busy} className="auth-submit-btn">
            {busy ? "Создаём…" : "Опубликовать опрос"}
          </button>
        </form>
      </div>
    </div>
  );
}
